<template>
  <router-view v-slot="{ Component, route }">
    <transition :name="transitionName" mode="out-in">
      <component :is="Component" :key="route.path" />
    </transition>
  </router-view>
  <CustomTabbar v-if="showTabbar" />
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import CustomTabbar from './components/CustomTabbar.vue'

const route = useRoute()
const previousPath = ref('')

// 定义需要显示 tabbar 的路由
const tabbarRoutes = ['/', '/order', '/teams', '/user', '/contact-task']

const showTabbar = computed(() => {
  return tabbarRoutes.includes(route.path)
})

// 根据路由变化决定切换动画方向
const transitionName = computed(() => {
  const currentPath = route.path
  const prevPath = previousPath.value
  
  // 如果是 tabbar 路由之间的切换，使用滑动动画
  if (tabbarRoutes.includes(prevPath) && tabbarRoutes.includes(currentPath)) {
    const prevIndex = tabbarRoutes.indexOf(prevPath)
    const currentIndex = tabbarRoutes.indexOf(currentPath)
    if (prevIndex !== -1 && currentIndex !== -1) {
      return prevIndex < currentIndex ? 'slide-left' : 'slide-right'
    }
  }
  
  // 其他情况使用淡入淡出
  return 'fade'
})

// 监听路由变化，更新 previousPath
watch(() => route.path, (newPath) => {
  previousPath.value = newPath
}, { immediate: true })
</script>

<style>
:root {
  --primary-color: #ff9f00;
  --bg-color: #f8f9fa;
  --text-main: #1a1a1a;
  --text-sub: #8e8e93;
  --card-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--bg-color);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-main);
}

/* Page Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Tabbar 路由之间的滑动切换 */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-left-enter-from {
  transform: translateX(100%);
}

.slide-left-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-right-enter-from {
  transform: translateX(-100%);
}

.slide-right-leave-to {
  transform: translateX(100%);
}

/* Global Vant Overrides */
.van-button--primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.van-tabbar-item--active {
  color: var(--primary-color) !important;
}

/* App 统一确认弹窗（密码提醒 / 退出登录等） */
.app-confirm-dialog.van-dialog,
.pwd-remind-dialog.van-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.app-confirm-dialog .van-dialog__footer,
.pwd-remind-dialog .van-dialog__footer {
  padding: 8px 16px 16px;
}

.app-confirm-dialog .van-dialog__cancel,
.app-confirm-dialog .van-dialog__confirm,
.pwd-remind-dialog .van-dialog__cancel,
.pwd-remind-dialog .van-dialog__confirm {
  flex: 1;
  height: 40px;
  margin: 0 4px;
  border-radius: 20px !important;
  border: none !important;
}

.app-confirm-dialog .van-dialog__cancel,
.app-confirm-dialog .van-dialog__footer .van-dialog__cancel,
.pwd-remind-dialog .van-dialog__cancel,
.pwd-remind-dialog .van-dialog__footer .van-dialog__cancel {
  background: #f2f3f5 !important;
  color: #646566 !important;
}

.app-confirm-dialog .van-dialog__confirm,
.app-confirm-dialog .van-dialog__confirm.van-button--default,
.app-confirm-dialog .van-dialog__footer .van-dialog__confirm,
.pwd-remind-dialog .van-dialog__confirm,
.pwd-remind-dialog .van-dialog__confirm.van-button--default,
.pwd-remind-dialog .van-dialog__footer .van-dialog__confirm {
  background: #ff9f00 !important;
  color: #fff !important;
}

.app-confirm-dialog .van-dialog__footer .van-button,
.pwd-remind-dialog .van-dialog__footer .van-button {
  border: none !important;
}
</style>
